import React from 'react';

let permissions = [];
let selectedPermission = {};
let permisosFicha = [];
let permisosProforma = [];
let permisosPedidos = [];
let pedidosErroneos = [];

export function getPermisosPedidos() {
  return permisosPedidos;
}

export function loadPermissions(results) {
  permisosFicha = results.permisosFicha;
  permisosProforma = results.permisosProforma;
  permisosPedidos = results.permisosPedidos;
  permissions = [...permisosFicha, ...permisosProforma, ...permisosPedidos];
}

export function getPermission(e,id) {
  if(e.target.dataset.permisos) {
    if(typeof(id) === 'undefined' || id === null || id === '') {
      selectedPermission = permissions.find(fdv => fdv.permisoTag === e.target.dataset.permisos);
    } else {
      selectedPermission = permissions.find(fdv => fdv.permisoTag === e.target.dataset.permisos && (fdv.num_proforma === id || fdv.num_pedido === id));
    }
    return selectedPermission;
  } else {
    return {};
  }
}

export function isPermissionValid() {
  if (selectedPermission) {
    return (selectedPermission.valuePermiso === 'V');
  } else {
    return false;
  }
}

export function hasPermissionMessage() {
  if (selectedPermission) {
    return (typeof(selectedPermission.mensaje) !== 'undefined' &&
    selectedPermission.mensaje !== null &&
    selectedPermission.mensaje !== '');
  } else {
    return false;
  }
}

export function validatePermissions(e,id) {
  e.persist();
  let selectedPermission = {};
  let permission = {};
  selectedPermission = getPermission(e,id);
  permission['valid'] = isPermissionValid();
  permission['message'] = selectedPermission.mensaje;
  /*if(!isPermissionValid()) {
    e.target.setAttribute('disabled','disabled');
  }*/
  return permission;
}

export function validatePermissionsMassive(e,list) {
    e.persist();
    pedidosErroneos = permisosPedidos.filter(pedido => existsPedido(list,pedido.num_pedido) &&
      pedido.valuePermiso !== 'V' &&
      pedido.permisoTag === e.target.dataset.permisos);
    /*if(!isValidProcessMassive()) {
      e.target.setAttribute('disabled','disabled');
    }*/
    return <lu>
      {
        pedidosErroneos.map(errors => (
          <li key={errors.num_pedido}>
            {(errors.mensaje !== null && errors.mensaje !== ''
              ? errors.mensaje
              : 'no tiene permisos')}
          </li>
        ))
      }
    </lu>;
}

export function existsPedido(list,pedido) {
  return (typeof(list.find(e => e === pedido))!=='undefined');
}

export function isValidProcessMassive() {
  return (pedidosErroneos.length === 0);
}



// WEBPACK FOOTER //
// ./src/utils/permissions.js